// src/components/WorkflowItem.js
import React, { useCallback } from "react";

const WorkflowItem = ({ file, tags }) => {
  const getName = (file) => {
    const name = file.split("_");
    name.shift();
    const originalName = name.join(" / ");

    // 添加显示名称映射
    const displayNameMappings = {
      "GCode Generator": "3D Printing",
      // 你可以在这里添加更多映射
      // 'Wire mesh sculpture': 'Wire Mesh Sculpture',
      // 'Laser cut Interlocking planar': 'Interlocking Planar Cuts',
    };

    return displayNameMappings[originalName] || originalName;
  };

  const title = getName(file);

  // Improved drag start handler that uses the global function
  const handleDragStart = useCallback(
    (e) => {
      e.dataTransfer.setData("text/plain", file);

      // Set allowed effect to copy for indicating multiple selection
      e.dataTransfer.effectAllowed = "copy";

      // Use the global function to track dragged items
      if (window.addToDraggedItems) {
        window.addToDraggedItems(file);
      }

      // Show drag overlay if you have one
      const dragOverlay = document.getElementById("drag-overlay");
      if (dragOverlay) {
        dragOverlay.style.display = "block";
      }

      // Add active dragging class to element
      e.currentTarget.classList.add("dragging");
    },
    [file]
  );

  // Handle drag end to clean up visual states
  const handleDragEnd = useCallback((e) => {
    e.currentTarget.classList.remove("dragging");

    // Hide drag overlay when drag operation completes
    const dragOverlay = document.getElementById("drag-overlay");
    if (dragOverlay) {
      setTimeout(() => {
        dragOverlay.style.display = "none";
      }, 100); // Small delay to ensure drag operation is complete
    }
  }, []);

  return (
    <div
      className="card"
      data-workflow={file}
      draggable="true"
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={{
        cursor: "move",
        backgroundColor: "white",
        borderRadius: "8px",
        overflow: "hidden",
        marginBottom: "15px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
      }}
    >
      <div style={{ padding: "0" }}>
        <div style={{ overflow: "hidden" }}>
          <img
            src={`/images/${file}.jpg`}
            alt={title}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
            loading="lazy"
          />
        </div>
        <div style={{ padding: "12px" }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "1.1rem",
              color: "#444",
              margin: "0 0 8px 0",
            }}
          >
            {title}
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {tags &&
              Object.entries(tags).map(([dimension, dimensionTags]) =>
                dimensionTags?.map((tag) => {
                  // 根据维度设置颜色
                  const getColorByDimension = (dim) => {
                    switch (dim) {
                      case "Product-related Dimensions":
                        return "#e3f2fd";
                      case "Structure-related Dimensions":
                        return "#f3e5f5";
                      case "Machine-related Dimensions":
                        return "#e8f5e8";
                      default:
                        return "#f0f0f0";
                    }
                  };

                  return (
                    <span
                      key={`${dimension}-${tag}`}
                      style={{
                        display: "inline-block",
                        padding: "3px 8px",
                        backgroundColor: getColorByDimension(dimension),
                        borderRadius: "12px",
                        margin: "2px",
                        fontSize: "11px",
                        border: "1px solid #ddd",
                      }}
                    >
                      {tag}
                    </span>
                  );
                })
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowItem;
